// Admin yönlendirmeleri: iki alanın parçaları (yollar `/` köküne göre). A01 genel bakış business alanındadır (index).
import { adminBusinessRoutes } from './areas/business/routes';
import { adminPlatformRoutes } from './areas/platform/routes';

export const adminRoutes = (
  <>
    {adminBusinessRoutes}
    {adminPlatformRoutes}
  </>
);
